/** Customer.io segment for deluxe edition notifications (legacy: CustomerIOManager.AddSegment 656). */
export const DELUXE_EDITION_SEGMENT_ID = 656
